import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SettingsSheet from './SettingsSheet';
import { useTranslation } from '../contexts/LanguageContext';
import { useSettingsSheet } from '../context/SettingsSheetContext';
import '../styles/components/Header.css';

const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const { open } = useSettingsSheet();

  return (
    <>
      {/* Desktop / Tablet header */}
      <header className="header">
        <div className="header-inner">
          <Link to="/" className="logo">
            <div className="logo-icon">&#127911;</div>
            <span className="logo-title">{t('siteTitle')}</span>
          </Link>

          <nav className="nav-desktop">
            <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
              {t('home')}
            </Link>
            <Link to="/browse" className={`nav-link ${isActive('/browse') ? 'active' : ''}`}>
              {t('browse')}
            </Link>
            <Link to="/search" className={`nav-link ${isActive('/search') ? 'active' : ''}`}>
              {t('search')}
            </Link>
            <Link to="/queue" className={`nav-link ${isActive('/queue') ? 'active' : ''}`}>
              {t('queue')}
            </Link>
          </nav>

          <div className="header-controls">
            <button
              type="button"
              className="settings-btn"
              onClick={() => open()}
              aria-label={t('settings')}
              title={t('settings')}
            >
              <span aria-hidden="true">&#9881;</span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile bottom tab bar */}
      <nav className="mobile-tabs" aria-label="Main navigation">
        <Link to="/" className={`tab ${isActive('/') ? 'active' : ''}`}>
          <span className="tab-icon">&#127911;</span>
          <span className="tab-label">{t('home')}</span>
        </Link>
        <Link to="/browse" className={`tab ${isActive('/browse') ? 'active' : ''}`}>
          <span className="tab-icon">&#128197;</span>
          <span className="tab-label">{t('browse')}</span>
        </Link>
        <Link to="/search" className={`tab ${isActive('/search') ? 'active' : ''}`}>
          <span className="tab-icon">&#128269;</span>
          <span className="tab-label">{t('search')}</span>
        </Link>
        <Link to="/queue" className={`tab ${isActive('/queue') ? 'active' : ''}`}>
          <span className="tab-icon">&#9776;</span>
          <span className="tab-label">{t('queue')}</span>
        </Link>
        <button type="button" className="tab" onClick={() => open()}>
          <span className="tab-icon">&#9881;</span>
          <span className="tab-label">{t('settings')}</span>
        </button>
      </nav>

      {/* Settings (theme + language + downloads) */}
      <SettingsSheet />
    </>
  );
};

export default Header;
